import { OpsanioWaves } from "src/questionnaires";

/**
 * The one wave palette for the appliance views: table badges, flyout header,
 * fleet chips and the wave donut all read it, so a wave has the same colour
 * everywhere (there used to be four diverging maps).
 *
 * OUI's colour-blind-safe visualisation palette: the hues differ in lightness
 * as well, so neighbouring waves stay distinguishable without relying on hue
 * alone, and EuiBadge picks a readable text colour for each in both themes.
 */
export const WAVE_COLOR: Record<OpsanioWaves, string> = {
  dev: "#6092C0",
  qa: "#D6BF57",
  main: "#54B399",
  wave1: "#9170B8",
  wave2: "#CA8EAE",
  wave3: "#DA8B45",
  debug: "#E7664C",
};

/** Colour for a wave name that may be unknown or empty. */
export const waveColor = (wave?: string | null): string =>
  (wave && WAVE_COLOR[wave as OpsanioWaves]) || "hollow";

/** Display order of the waves (rollout order). */
export const WAVE_ORDER: OpsanioWaves[] = [
  "dev",
  "qa",
  "main",
  "wave1",
  "wave2",
  "wave3",
  "debug",
];
